import { Box } from '@mui/material';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { IJob } from 'wisestep-api';
import { ScrollableTabs, TabTextVariant } from 'wisestep-base';

import NoDataFoundCard from '../../../components/noDataFoundCard';
import JobPageParams from '../../../features/jobs/types/JobPageParams';
import useKeyWordGenerator, { Mode } from '../../../hooks/useKeyWordGenerator';
import CardWrapper from '../../automatedEmailCampaignSettings/childRoutes/CardWrapper';
import { sourcingTabList } from '../utils/sourcingHelper';

import { AISuggestions } from './AISuggestions';
import { SimilarJobs } from './similarJobs';
import { SocialSearch } from './SocialSearch';
import { JobTalentPool } from './talentPool';

const Sourcing = ({ job }: { job: IJob }) => {
  const params = useParams<JobPageParams>();
  const tab = Number(params.defaultJDTab ?? 0);
  const [tabIndex, setTabIndex] = useState<number>(tab);
  const navigate = useNavigate();
  const selectedTabIndex = (index: number) => {
    setTabIndex(index);
    navigate(`/jobs-crm/${job?.id ?? ''}/false/${index}/sourcing`);
  };
  const jobTalentPoolBooleanQuery = useKeyWordGenerator(Mode.TALENT_POOL, job);
  return (
    <Box sx={{ mt: 1 }}>
      <CardWrapper sx={{ pt: 0 }}>
        <ScrollableTabs
          scrollList={sourcingTabList}
          getTabIndex={selectedTabIndex}
          variant={TabTextVariant.SUB_TITLE}
          defaultValue={tabIndex}
        />
      </CardWrapper>
      {tabIndex === 0 && <AISuggestions job={job} />}
      {tabIndex === 1 && <SimilarJobs job={job} />}
      {tabIndex === 2 && <JobTalentPool job={job} booleanQuery={jobTalentPoolBooleanQuery} />}
      {tabIndex === 3 && (
        <NoDataFoundCard text="This feature will be released very soon — stay tuned!" />
      )}
      {tabIndex === 4 && <SocialSearch job={job} />}
    </Box>
  );
};

export default Sourcing;
